import { render, staticRenderFns } from "./ReserveTagEditor.vue?vue&type=template&id=6d0833c2&scoped=true"
import script from "./ReserveTagEditor.vue?vue&type=script&lang=js"
export * from "./ReserveTagEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0833c2",
  null
  
)

export default component.exports